<template>
    <div class="d-flex align-items-center">
        <div class="flex-grow-1 pe-0">
            <input type="text" class="form-control shadow-v2 text-muted"
                   v-model="selectedDateText"
                   @change="updateValue(1, $event)"
                   placeholder="dd/mm/aaaa"
                   v-maska="'##/##/####'"
                   :class="{ filledDateInputText: selectedDateText !== '' }"
                   :required="isRequired"
                   :disabled="disabled"
                   :readonly="readonly"/>
        </div>
        <div class="ps-0 pe-0" style="width: 45px; margin-left:-45px">
            <input class="form-control shadow-v2 text-muted"
                   type="date"
                   tabindex="-1"
                   v-model="selectedDate"
                   @change="updateValue(2, $event)"
                   :class="{ filledDateInputDate: selectedDate !== '' }"
                   :required="isRequired"
                   :disabled="disabled"
                   :readonly="readonly"/>
        </div>
    </div>

</template>

<script>
    import moment from "moment";
    import { Maska } from 'maska';


    export default {
        emits: ['update:modelValue'],
        props: {
            modelValue: {
                default: '',
            },
            todayByDefault: {
                type: Boolean,
                default: false,
            },
            isRequired: {
                type: Boolean,
                default: false,
            },
            customWidth: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            dateFormat: {
                type: String,
                default: "YYYY-DD-MM"
            },
            readonly: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                selectedDate: '',
                selectedDateText: '',
                initialValue: ''
            };
        },
        mounted() {
            if (this.todayByDefault) {
                this.initialValue = moment().format("YYYY-MM-DD");
            }

        },
        methods: {
            updateValue(campo, event) {
                var value = event.target.value;

                if (value == '') {
                    this.$emit('update:modelValue', value);
                    return

                }

                if (campo == 1) {
                    value = moment(value, "DD/MM/YYYY").format(this.dateFormat);
                    this.selectedDate = value;
                } else if (campo == 2) {
                    var data = moment(value, "YYYY-DD-DD").format("DD/MM/YYYY");
                    value = moment(value, "YYYY-MM-DD").format(this.dateFormat);

                    this.selectedDate = value;
                    this.selectedDateText = data;
                }
                this.$emit('update:modelValue', value);


            },
        },
        watch: {
            modelValue: {
                immediate: true,
                handler(newValue) {
                    if (newValue && newValue != '') {
                        this.selectedDate = newValue ? moment(newValue, this.dateFormat).format("YYYY-MM-DD") : this.initialValue;
                        this.selectedDateText = newValue ? moment(newValue, this.dateFormat).format("DD/MM/YYYY") : this.initialValue;
                    } else if (newValue == '') {
                        this.selectedDate = '';
                        this.selectedDateText = '';

                    }
                },
            }
        },
    };
</script>

<style scoped>
    .filledDateInputText {
        border-top: 1px solid rgb(41, 159, 74);
        border-left: 1px solid rgb(41, 159, 74);
        border-bottom: 1px solid rgb(41, 159, 74);
    }

    .filledDateInputDate {
        border-top: 1px solid rgb(41, 159, 74);
        border-right: 1px solid rgb(41, 159, 74);
        border-bottom: 1px solid rgb(41, 159, 74);
    }

    input[type="date"] {
        cursor: pointer;
    }

        input[type="date"]::-webkit-calendar-picker-indicator {
            cursor: pointer;
        }
</style>
